export const MENU_LABELS = {
  DASHBOARD: { label: "Dashboard", value: "dashboard" },

  FLAG_ISSUES: { label: "Flag Issues", value: "flagissues" },
  USER_REPORT: { label: "User Report", value: "userreport" },
  QUESTIONS_REPORT: { label: "Questions Report", value: "questionsreport" },
  RESULT_REPORT: { label: "Result Report", value: "resultreport" },

  REPORTS: { label: "Reports", value: "reports" },
  CONTEST_WISE_EARNING: { label: "Contest Wise Earning", value: "contestwiseearning" },
  SUBJECT_WISE_EARNING: { label: "Subject Wise Earning", value: "subjectwiseearning" },
  SLOT_TIME_EARNING: { label: "Slot Time Earning", value: "slottimeearning" },
  USER_EARNING: { label: "User Earning", value: "userearning" },
  CLASSES_EARNING: { label: "Classes Earning", value: "classesearning" },

  USERS: { label: "Users", value: "users" },
  ALL_USERS: { label: "All Users", value: "allusers" },
  USERDATA: { label: "User Data", value: "userdata" },
  ADD_NEW_USER: { label: "Add New User", value: "addnewuser" },
  KYC_VERIFICATION: { label: "KYC Verification", value: "kycverification" },

  CONTEST_MANAGEMENT: { label: "Contest Management", value: "contestmanagement" },
  ALL_CONTESTS: { label: "All Contests", value: "allcontests" },
  CONTEST_TYPES: { label: "Contest Types", value: "contesttypes" },
  CONTEST_LEADERBOARD: { label: "Contest Leaderboard", value: "contestleaderboard" },
  CONTEST_EARNINGS: { label: "Contest Earnings", value: "contestearnings" },
  GOAL_TYPES: { label: "Goal Types", value: "goaltypes" },
  EXAM_TYPES: { label: "Exam Types", value: "examtypes" },

  COURSES: { label: "Courses", value: "courses" },
  ALL_COURSES: { label: "All Courses", value: "allcourses" },
  MODULE: { label: "Module", value: "module" },
  COURSE_LECTURES: { label: "Course Lectures", value: "courselectures" },
  COURSE_PURCHASE: { label: "Course Purchase", value: "coursepurchase" },
  COURSE_FAQ: { label: "Course FAQ", value: "coursefaq" },

  WORKSHOPS: { label: "Workshops", value: "workshops" },
  ALL_WORKSHOPS: { label: "All Workshops", value: "allworkshops" },
  WORKSHOP_REGISTER: { label: "Workshop Register", value: "workshopregister" },
  WORKSHOP_LECTURES: { label: "Workshop Lectures", value: "workshoplectures" },
  WORKSHOP_TESTIMONIALS: { label: "Workshop Testimonials", value: "workshoptestimonials" },
  WORKSHOP_FAQ: { label: "Workshop FAQ", value: "workshopfaq" },

  WEBSITE_CONTENT: { label: "Website Content", value: "websitecontent" },
  INTERFACE: { label: "Interface", value: "interface" },
  ABOUT_US: { label: "About Us", value: "aboutus" },
  FEATURES: { label: "Features", value: "features" },
  HOW_IT_WORKS: { label: "How It Works", value: "howitworks" },
  FAQ: { label: "FAQ", value: "faq" },
  TRUSTED_BY: { label: "Trusted By", value: "trustedby" },
  BANNERS: { label: "Banners", value: "banners" },
  BLOG: { label: "Blog", value: "blog" },
  CONTACT_ENQUIRIES: { label: "Contact Enquiries", value: "contactenquiries" },

  FINANCE_MANAGEMENT: { label: "Finance Management", value: "financemanagement" },
  INCOME_EXPENSE: { label: "Income & Expense", value: "incomeexpense" },
  WITHDRAWAL: { label: "Withdrawal", value: "withdrawal" },
  WITHDRAWAL_REQUEST: { label: "Withdrawal Request", value: "withdrawalrequest" },
  REFUND_POLICY: { label: "Refund Policy", value: "refundpolicy" },

  LEGAL_DOCUMENTS: { label: "Legal Documents", value: "legaldocuments" },
  TERMS_CONDITIONS: { label: "Terms & Conditions", value: "termsconditions" },
  PRIVACY_POLICY: { label: "Privacy Policy", value: "privacypolicy" },
  LEGALITY: { label: "Legality", value: "legality" },

  QUESTION_MANAGEMENT: { label: "Question Management", value: "questionmanagement" },
  QUESTIONS: { label: "Questions", value: "questions" },
  COPY_QUESTIONS: { label: "Copy Questions", value: "copyquestions" },
  SUBJECTS_SUBTOPICS: { label: "Subjects & Subtopics", value: "subjectssubtopics" },

  YOUTUBE_VISUALS: { label: "Youtube Visuals", value: "youtubevisuals" },
  SOCIAL_MEDIA_ENGAGE: { label: "Social Media Engage", value: "socialmediaengage" },
  COUPON_CODE: { label: "Coupon Code", value: "couponcode" },
  MOCK_TEST_DISCOUNT: { label: "Mock Test Discount", value: "mocktestdiscount" },
  FREE_MOCK_TEST: { label: "Free Mock Test Leads", value: "freemocktest" },
  SETTING: { label: "Setting", value: "setting" },

  PAYMENT_MESSAGE: { label: "Payment Message", value: "paymentmessage" },
  CLASSES: { label: "Classes", value: "classes" },
  USER_ADMIN: { label: "User Admin", value: "useradmin" },
};
